import { render } from "./WarriorsView.vue?vue&type=template&id=1de2b6be"
import script from "./WarriorsView.vue?vue&type=script&lang=js"
export * from "./WarriorsView.vue?vue&type=script&lang=js"

import "./WarriorsView.vue?vue&type=style&index=0&id=1de2b6be&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__